<a *ngIf="news && news.metadata?.link" [href]="news.metadata.link" target="_blank">
  <div class="news-card" *ngIf="news" [class.multi]="multiClaims" [class.highlight]="news.metadata.highlight_priority >= 10">
    <div class="news-img" routerLink="{{ news.metadata.link }}">
  <div class="img-bg" [style.background-image]="'url(' + bgImageUrl + ')'" role="img" [attr.aria-label]="news && news.metadata && news.metadata.title ? news.metadata.title : 'news image'"></div>
    </div>
    <div class="news-main">
      <div class="outstanding-message">
        <span class="circle"></span>
        <p class="label">{{ news.metadata.bullet }}</p>
      </div>

      <div class="news-title">
        <a target="_blank">
          {{ news.metadata.title }}
        </a>
      </div>
    </div>
  </div>
</a>
